import apiBids from '../../api/apiBids'


const state = {
    brands: [],
    models: [],
    bids: [],
    currentPage: null,
    lastPage: null,
    query: {
        user_id: null,
        brand: null,
        models: [],
        grades: [],
        carGrade: null,
        chassis: [],
        lots: [],
        auctions: null,
        date: null,
        page: 1,
        order_column: 'lot_date',
        order_type: 'DESC',
        status: null,
        type: null,
        manager: null
    },
    bidGroups: [],
    bidGroupLimits: '',
    totalBids: 0

}

const getters = {
    getBids: (state) => {
        return state.bids
    },
    getCurrentBidsPage: (state) => {
        return state.currentPage
    },
    getLastBidsPage: (state) => {
        return state.lastPage
    },
    isLastBidsPage: (state) => {
        return state.currentPage === state.lastPage
    },
    getBidsQuery: (state) => {
        return state.query
    },
    getBidsOrderColumn: (state) => {
        return state.query.order_column
    },
    getOrderType: (state) => {
        return state.query.order_type
    },
    getTotalBids: (state) => {
        return state.totalBids
    }
}

const mutations = {
    setBidsQueryDate: (sate, newValue) => {
        sate.query.date = newValue
    },
    setBidsUserId: (state, newValue) => {
        state.query.user_id = newValue
    },
    setOrderColumn: (state, newValue) => {
        state.query.order_column = newValue
    },
    setOrderType: (state, newValue) => {
        state.query.order_type = newValue
    },
    setBids: (state, newBids) => {
        state.bids = newBids
    },
    setTotalBids: (state, newValue) => {
        state.totalBids = newValue
    },
    setCurrentBidsPage: (state, pageNumber) => {
        state.currentPage = pageNumber
        state.query.page = pageNumber
    },
    setLastBidsPage: (state, pageNumber) => {
        state.lastPage = pageNumber
    },
    updateBids: (state, newBids) => {
        state.bids = state.bids.concat(newBids)
    },
    setDefaultBidsQuery: (state) => {
        const defaultQ = {
            user_id: null,
            brand: null,
            models: [],
            grades: [],
            carGrade: null,
            chassis: [],
            lots: [],
            auctions: null,
            date: null,
            page: 1,
            order_column: 'lot_date',
            order_type: 'DESC',
            status: null,
            type: null,
            manager: null
        }
        state.query = Object.assign({}, defaultQ)
    }
}

const actions = {
    fetchBids: ({ commit, dispatch, getters }) => {
        dispatch('setStatusLoading')
        apiBids
            .bidsListRequest(getters.getBidsQuery)
            .then((response) => {
                commit('setTotalBids', response.data.total)
                commit('setBids', response.data.data)
                commit('setCurrentBidsPage', response.data.current_page)
                commit('setLastBidsPage', response.data.last_page)
                dispatch('setStatusLoaded')
            })
    },
    // alternative way { commit, dispatch, getters } <- gets only these methods from context variable
    loadMoreBids: (context) => {
        context.commit('setCurrentBidsPage', (context.getters.getCurrentBidsPage + 1))
        apiBids
            .bidsListRequest(context.getters.getBidsQuery)
            .then((response) => {
                context.commit('updateBids', response.data.data)
            })
            .catch(error => console.log(error))
    },
    clearBidsQuery: ({ commit }) => {
        commit('setDefaultBidsQuery')
    },
    setNewOrderColumn: ({ commit }, newValue) => {
        commit('setOrderColumn', newValue)
    },
    setNewBidsUserId: ({ commit }, newValue) => {
        commit('setBidsUserId', newValue)
    },
    setNewOrderType: ({ commit }, newValue) => {
        commit('setOrderType', newValue)
    },
    setBidsNewQueryDate: ({ commit }, newValue) => {
        commit('setBidsQueryDate', newValue)
    },
    fetchBidsWithSearchQuery: (context) => {
        context.dispatch('setStatusLoading')
        apiBids
            .bidsListRequest(context.getters.getBidsQuery)
            .then((response) => {
                context.commit('setTotalBids', response.data.total)
                context.commit('setBids', response.data.data)
                context.commit('setCurrentBidsPage', response.data.current_page)
                context.commit('setLastBidsPage', response.data.last_page)
                context.dispatch('setStatusLoaded')
            })
            .catch(error => console.log(error))
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/bids.js